<template>
    <div>
        <h4 v-lang.need_help></h4>
        <div class="help">
            <span v-lang.need_help_secondary></span>
            <div class="phone">
                <i class="fa fa-phone"></i>
                <a href="tel:18475555555"> {{ phone }} </a>
            </div>
            <div class="email">
                <i class="fa  fa-envelope-o "></i>
                <a v-bind:href="mailto">{{ email }}</a> <span v-lang.or_use></span>  <router-link to="/site/contact" v-lang.contact_form></router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash';
    export default
    {
        data : function(){
            return {
                phone : null,
                email : null
            }
        },
        computed : {
            mailto : function(){
                return `mailto:${this.email}`;
            }
        },
        created : function()
        {
            let self = this;
            this.$store.watch( (state)=> {return this.$store.getters.config; }, (val) => {
                self.phone = val.contact.phone;
                self.email = val.contact.email;
            });
        },
        mounted : function()
        {
            let self = this;
            let config = this.$store.getters.config;
            if( !_.isNull(config) )
            {
                self.phone = config.contact.phone;
                self.email = config.contact.email;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// help.vue?485b1ed8